module.exports =
  '_PAYMENT':
    'INTRO':
      'TITLE': 'アップグレード'
      'BUTTON_SPECIAL': '有料会員になる'
      'BUTTON_SPECIAL_HINT': '月額 500円（税抜)'
      'TITLE1': 'この機能をお使いいただくには、有料会員への登録が必要です。'
      'TITLE2': 'より充実した機能で、自分の実力を分析しよう！'
      'TITLE3': '有料会員(月額５００円)にご登録いただくと、より詳細なスコア分析／コース分析を利用できます。'
      'CONTENT1': '目標値の設定'
      'CONTENT2': 'コース別スコアの比較'
      'CONTENT3': 'ＰＣからのスコア編集'
      'DESCRIPTION1': '目標を明確にすることが上達への近道、個人の目標データを入力しましょう。'
      'DESCRIPTION2': '個人のラウンド結果やコース平均との比較ができます。'
      'DESCRIPTION3': 'モバイルアプリで入力してスコアデータを後からＰＣで編集することも可能です。'
    'WEB_CANCEL':
      'HEADER': '有料会員を解約すると、下記の限定機能がご利用いただけなくなります。'
      'TITLE': '有料会員限定機能'
      'TEXT_CONTENT_PART1': 'すぐに解約される方は、「解約する」ボタンより解約手続きを行ってください。'
      'TEXT_CONTENT_PART2': '引き続きご利用いただく方は「閉じる」ボタンを押してください。'
    'APP_CANCEL':
      'HEADER' : '【ご注意ください】'
      'HEADER_TEXT1' : '解約手続きを行うと、その当日から有料サービスのご利用ができなくなります。'
      'HEADER_TEXT2' : 'あらかじめご了承ください。'

      'EXPLAIN' : 'お客様は、ウェブサービス版ならびにアプリ版から有料会員の解約を行うことができません。'
      'EXPLAIN_TEXT1' : 'Google Play もしくは Apple ID より有料会員にご登録いただいておりますので、'
      'EXPLAIN_TEXT2' : 'ご利用の各プラットフォームより、購読を中止頂く必要がございます。'

      'LIST' : '操作方法は、下記のとおりでございます。'

      'GOOGLE_HEADER': '【Google Play をご利用の場合】'
      'GOOGLE_TEXT1' : 'Google Playより'
      'GOOGLE_TEXT2' : 'GOLF NETWORK PLUS アプリをご表示いただきまして、'
      'GOOGLE_TEXT3' : '画面内に表れます購読のキャンセルを実施してください。'

      'APPLE_HEADER' : '【Apple ID 課金をご利用の場合】'
      'APPLE_TEXT1' : 'App Storeより'
      'APPLE_TEXT2' : 'おすすめ＞Apple ID（ログイン）＞購読：管理'
      'APPLE_TEXT3' : '上記の操作にて、解約手続きに進んでください。'
    'TV_CANCEL':
      'HEADER': '【ご注意ください】'
      'HEADER_TEXT1' : '解約手続きを行うと、その当日から有料サービスのご利用ができなくなります。'
      'HEADER_TEXT2' : 'あらかじめご了承ください。'

      'DESCRIPTION1' : 'お客様は、GN+ TV サイトより有料会員にご登録いただいておりますため、'
      'DESCRIPTION2' : '下記のリンクより解約手続きへお進みください。'
      'DESCRIPTION3' : '有料会員の解約手続き（GN+ TVサイトへ遷移します）'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/i18n/ja.coffee